import { useEffect, useState } from 'react';
import { Alert as MetAlert, AlertProps, Box } from '@ally/metronome-ui';

type IProps = {
  children?: React.ReactNode;
  show: boolean;
} & AlertProps;

const Alert: React.FC<IProps> = (props: IProps) => {
  const { show, children, cancellable, handleClose, ...alertProps } = props;
  const [showAlert, setShowAlert] = useState<boolean>(false);

  useEffect(() => {
    setShowAlert(show);
  }, [show]);

  return (
    <>
      {showAlert && (
        <Box marginBottom='20px'>
          {cancellable === false ? (
            <MetAlert {...(alertProps as any)} cancellable={false} />
          ) : (
            <MetAlert
              {...(alertProps as any)}
              cancellable
              handleClose={handleClose || (() => setShowAlert(false))}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default Alert;
